<template>
  <div>
    <v-layout column class="mt-4 ml-4">
      <header-elements icon='mdi-track-light' @showUpload="showUpload=!showUpload" title='Lights'></header-elements>
      <elements-table :items="lights" :showUpload="showUpload" @showUpload="showUpload=!showUpload" title="Light"></elements-table>

        <!-- <div class="mt-4 mb-3">
          <v-flex style="background-color:#e2e2e2;" class="px-3 py-2 elevation-1 xs12">
            <h3 class="subtitle xs12 flex">Lights</h3>
            </v-flex>
        </div>       -->
        <!-- <v-flex xs12 sm12 md12  v-if="lights && lights.length>0">
          <v-list class="xs12">
            <v-list-tile v-for="f in lights" :key="f.id">
              <v-list-tile-title>
                <b>{{f.title}}</b>
              </v-list-tile-title>
              <v-list-tile-title>light_container: {{f.light_container}}</v-list-tile-title>
              <v-list-tile-title>bitrate: {{f.bitrate}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_light" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_light" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
        </v-flex> -->
        <!-- <v-flex class="mt-0 mb-0 xs12" v-show="!showUpload">
          <v-btn icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn> Add new light
        </v-flex> -->
        <v-flex class="mt-0 mb-0 xs12" v-show="showUpload">
          <v-btn icon @click="showUpload=!showUpload"><v-icon>close</v-icon></v-btn> Cancel
        </v-flex>
        <v-flex v-if="showUpload">
          <v-container grid-list-xs fluid  class="elevation-3">
            <v-layout row wrap>
              <h4 class="headline">Add new light</h4>
              <edit-field-comp v-for="field in fields" v-show="show_field_c(field)" :id="field.name" :name="field.name"
                :class="'flex ' + (field.class ? field.class : 'xs12')" :artwork="artwork" 
                :field="field" 
                :key="field.key"
                :parent="light"
                v-model="field.name" 
              >
              </edit-field-comp>
            </v-layout>
          </v-container>
          <v-btn @click="add">save</v-btn>
          <v-btn @click="showUpload=!showUpload">cancel</v-btn>
        </v-flex>
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
  const show_field = (field) => {
    if (field.condition && light) {
      var theInstructions = field.condition;
      var F = (theInstructions) => {}
      return(F());
    } else {
      return true
    }
  }
  import EditFieldComp from './EditFieldComp'
  import HeaderElements from './HeaderElements'
  import ElementsTable from './ElementsTable'
  export default {
    props: ['artwork'],
    data: () => ({
      lights: [],
      light: {
        duration: 0,
        frequency: '',
        color: '',
        temperature: '',
        filesize: '',
        other_specifications: '',
        associated_programme: '',
        associated_information: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [
        {
          'ctype': 'text-short',
          'name': 'light.title',
          'title': 'Title',
          column: true,
          class: 'xs12',
          edit: true,
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'etype': 'radio',
          'selection': [
            {id: '1', value: '1', name: 'Endless'},
            {id: '2', value: '2', name: 'Looped'},
            {id: '3', value: '3', name: 'Time'},
            {id: '4', value: '4', name: 'Blinking'}
          ],
          'name': 'light.duration',
          'title': 'Duration',
          class: 'xs12',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'light.frequency',
          'title': 'Frequency',
          hint: '50 Hz, 60 Hz …',
          suffix: 'Hz',
          class: 'xs6',
          work_types: ['fvs'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'light.color',
          'title': 'Color',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'light.temperature',
          'title': 'Temperature',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'light.associated_programme',
          'title': 'Associated Programme',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'light.filesize',
          'title': 'File Size',
          column: true,
          suffix: 'MB',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'light.other_specifications',
          'title': 'Other Specifications',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'light.associated_information',
          'title': 'Associated Information carriers (format migration story)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'date',
          'name': 'light.creation_date',
          'title': 'Creation Date)',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'name': 'light.notes',
          'title': 'Notes)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
      ]
    }),
    methods: {
      set_input(f) {
        light[f]= f
      },
      download () {},
      add () {
        this.lights.push(this.light)
        this.showUpload=!this.showUpload
      },
      delete_light () {},
      done_light () {},
      show_field_c (field) {
        // console.log(this.light)
        return show_field(field,this.light)
      }
    },
    computed: {
    },
    components: {EditFieldComp,HeaderElements,ElementsTable}
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artworks/Light.vue